import { Pipe, PipeTransform } from '@angular/core';
import { DepartmentEstimate } from '@interfaces/DepartmentEstimate';

@Pipe({
  name: 'hoursCost'
})
export class HoursCostPipe implements PipeTransform {
  public transform(departmentEstimate: DepartmentEstimate): number {
    let total = 0;
    const classificationTotals = {};

    for (const estimateLine of departmentEstimate.estimateLines) {
      for (const classificationLine of estimateLine.classificationLines) {
        classificationTotals[classificationLine.classificationEstimateId] = classificationLine.hours;
        total += classificationLine.hours * classificationLine.rateCost;
      }
    }

    return total;
  }
}
